/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactDto as FeatureContactsContactDto } from '../../models/feature/contacts/contact-dto';
import { CreateContactDto as FeatureContactsCreateContactDto } from '../../models/feature/contacts/create-contact-dto';

export interface CreateContact$Params {
      body: FeatureContactsCreateContactDto
}

export function createContact(http: HttpClient, rootUrl: string, params: CreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureContactsContactDto>> {
  const rb = new RequestBuilder(rootUrl, createContact.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<FeatureContactsContactDto>;
    })
  );
}

createContact.PATH = '/contacts';

function reviveFeatureContactsContactDto(value: any): any {
  if (value) {
    if (value["archivedOn"] != null) {
      value["archivedOn"] = parseDateTime(value["archivedOn"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveFeatureContactsContactDto(body);
  }
  return body;
}
